import React, { FC } from "react";
import {
  Conversation,
  Search,
  Sidebar,
  ConversationList,
  Avatar,
} from "@chatscope/chat-ui-kit-react";
import { useSubscription } from "@apollo/client";
import UserIcon from "../assets/images/userIcon.png";
import { useStoreState, useStoreActions } from "../myStore";
import { getUserId } from "../utils/utilsFunctions";
import { TYPING_SUBSCRIPTION } from "../Apollo/graphql/Subscription/TypingSubscription";

const userId = getUserId();

interface CProps {
  setCurrentChat?: any;
  currentChat?: any;
  isAdmin?: Boolean;
}
const Channels: FC<CProps> = ({ setCurrentChat, currentChat, isAdmin }) => {
  const channels = useStoreState((state) =>
    isAdmin ? state.chat.allChannels : state.chat.channels
  );
  const setChannels = useStoreActions((actions) =>
    isAdmin ? actions.chat.setChannels : actions.chat.setAllChannels
  );

  useSubscription(TYPING_SUBSCRIPTION, {
    onSubscriptionData: ({ subscriptionData: { data } }) => {
      const channelsCopy = [...channels];
      const channelIndex = channelsCopy.findIndex(
        (c) => c._id === currentChat._id
      );
      if (channelIndex >= 0) {
        const newChannel = {
          ...channelsCopy[channelIndex],
          typing: data?.typing || null,
        };
        channelsCopy[channelIndex] = newChannel;
      }
      setChannels(channelsCopy);
    },
  });

  return (
    <Sidebar>
      <Search placeholder="Search" className="message-search" />
      <ConversationList>
        {channels &&
          channels.map((channel: any) => {
            const otherMember =
              channel &&
              channel.members &&
              channel.members
                .map((member: any) => {
                  return isAdmin || member._id !== userId
                    ? `${member?.firstName} ${
                        member?.lastName ? `${member.lastName}` : ""
                      }`
                    : null;
                })
                .join(",");
            return (
              <Conversation
                key={channel._id}
                name={otherMember}
                info={
                  channel.latestMessage?.type === "text"
                    ? channel.latestMessage?.message
                    : "Attachment"
                }
                onClick={() => {
                  setCurrentChat(channel);
                }}
              >
                
                  <Avatar src={UserIcon} name={otherMember} size="md" />
                
              </Conversation>
            );
          })}
      </ConversationList>
    </Sidebar>
  );
};

export default Channels;
